import { render, staticRenderFns } from "./ziyuan222.vue?vue&type=template&id=127520fe&"
import script from "./ziyuan222.vue?vue&type=script&lang=js&"
export * from "./ziyuan222.vue?vue&type=script&lang=js&"
import style0 from "./ziyuan222.vue?vue&type=style&index=0&id=127520fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports